import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import DetailsIcon from '@/svg-icons/details';

const PhotoBuildingDetailsSection = ({ data }) => (
  <div className="w-full">
    <div className="font-bold text-[calc(6px+0.4vw)] my-[0.6vw] flex items-center">
      <DetailsIcon className="text-gray-700 mr-2 w-6 h-6 shrink-0" />
      <FormattedMessage id="propertyInformations" />
    </div>

    <div className="flex flex-wrap text-[#858585] text-[calc(6px+0.4vw)] my-[1vw] pl-[calc(14px+1.8vw)]">
      {data.area ? (
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-photo-building-details-area">
          <div className="font-bold">
            <FormattedMessage id="area" />
          </div>
          {`${data.area} m²`}
        </div>
      ) : null}
      
      {data.roomsCount ? (
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-photo-building-details-rooms-count">
          <div className="font-bold">
            <FormattedMessage id="roomsCount" />
          </div>
          {data.roomsCount}
        </div>
      ) : null}
      
      {data.suitesCount ? (
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-photo-building-details-suites-count">
          <div className="font-bold">
            <FormattedMessage id="suitesCount" />
          </div>
          {data.suitesCount}
        </div>
      ) : null}
      
      {data.furnished ? (
        <div className="w-1/2 mb-[1vw]" data-cy="order-details-photo-building-details-furnished">
          <div className="font-bold">
            <FormattedMessage id="furnished" />
          </div>
          <FormattedMessage id={data.furnished} />
        </div>
      ) : null}
      
      {data.specificCharacteristics ? (
        <div className="w-full mb-[1vw]" data-cy="order-details-photo-building-details-specific-characteristics">
          <div className="font-bold">
            <FormattedMessage id="specificCharacteristics" />
          </div>
          <div className="whitespace-pre-wrap">
            {data.specificCharacteristics}
          </div>
        </div>
      ) : null}
      
      {data.rooms && data.rooms.length > 0 ? (
        <div className="w-full mb-[1vw]">
          <div className="font-bold">
            <FormattedMessage id="GENERAL_FEATURES" />
          </div>
          <div className="flex flex-wrap" data-cy="order-details-photo-building-details-rooms">
            {data.rooms.map(room => (
              <div key={room} className="w-1/2" data-cy={`order-details-photo-building-details-room-${room}`}>
                {room}
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  </div>
);

PhotoBuildingDetailsSection.propTypes = {
  data: PropTypes.object.isRequired,
};

export default PhotoBuildingDetailsSection;
